import { safeTrim } from '~/glm/utils/strings';

export const objectSort = (arr, objKey, asc = true) =>
  arr.sort((a, b) => {
    const propA = typeof a[objKey] === 'string' ? a[objKey].toUpperCase() : a[objKey];
    const propB = typeof b[objKey] === 'string' ? b[objKey].toUpperCase() : b[objKey];

    if (propA < propB) {
      return asc ? -1 : 1;
    }

    if (propA > propB) {
      return asc ? 1 : -1;
    }

    return 0;
  });

export const sortGuestsByEventInvitation = (guests, options) => {
  const { eventId, sortAttr, asc } = options;
  guests.map(g => {
    const invitation = g.invitationList.find(invite => invite.eventId === eventId);
    // eslint-disable-next-line no-nested-ternary
    const propToSortBy = invitation ? (invitation[sortAttr] === null ? '' : invitation[sortAttr].toString()) : null;
    return Object.assign(g, { propToSortBy });
  });

  return objectSort(guests, 'propToSortBy', asc);
};

export const sortGuestsByName = (guests, options) => {
  const { sortAttr, asc } = options;
  const sortableGuests = guests.map(g =>
    Object.assign(g, {
      propToSortBy:
        sortAttr === 'firstName'
          ? `${safeTrim(g.firstName)}${safeTrim(g.lastName)}`
          : `${safeTrim(g.lastName)}${safeTrim(g.firstName)}`,
    })
  );

  return objectSort(sortableGuests, 'propToSortBy', asc);
};

export const sortPartiesByLeaderName = (parties, options) => {
  const { asc, sortAttr } = options;
  const sortableParties = parties.map(p =>
    Object.assign(p, {
      propToSortBy:
        sortAttr === 'firstName'
          ? `${safeTrim(p.leaderPerson.firstName)}${safeTrim(p.leaderPerson.lastName)}`
          : `${safeTrim(p.leaderPerson.lastName)}${safeTrim(p.leaderPerson.firstName)}`,
    })
  );

  return objectSort(sortableParties, 'propToSortBy', asc);
};

export const sortHouseholdsByName = (households, asc) => objectSort(households, 'name', asc);
